import React from 'react';
import { SeoFooterLinkListProps, ResultsFieldLink } from '../../../component-props';
import {
  withDatasourceCheck,
  LinkField,
  Link as JssLink,
  Text as JssText,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { FooterSeoFrame } from '@greystar/designsystem';

const transformEditableLinks = (links: LinkField[]): JSX.Element[] => {
  const transformedLinks: JSX.Element[] = [];

  links.forEach((link) => {
    transformedLinks.push(<JssLink field={link} />);
  });
  return transformedLinks;
};

const SeoFooterLinkList = (props: SeoFooterLinkListProps): JSX.Element => {
  const datasource = props.fields?.data?.datasource;

  if (datasource) {
    const links = datasource.children.results.map(
      (element: ResultsFieldLink) => element.field.link
    );

    const editableLinks = transformEditableLinks(links);
    const editableTitle = datasource.field.title ? (
      <JssText field={datasource.field.title} />
    ) : (
      <></>
    );

    return <FooterSeoFrame title={editableTitle} links={editableLinks} />;
  }

  return <></>;
};

export default withDatasourceCheck()<SeoFooterLinkListProps>(SeoFooterLinkList);
